//
//
//
//
//
//

import Cookies from 'js-cookie';
export default {
  name: 'App',
  computed: {
    startShow: function startShow() {
      var state = this.$store.state.user;
      return !(state.gotInfo && state.rule.length === 0);
    }
  },
  created: function created() {
    this.checkLang();
  },
  methods: {
    checkLang: function checkLang() {
      var lang = Cookies.get('localeData');
      if (lang) {
        this.$i18n.locale = lang;
      }
    }
  }
};